<template>
  <div style="max-width: 850px; margin: 0px auto">
    <div class="section-header">
      <i 
        class="material-icons clickable" 
        @click="$router.push('/c/assessments')">arrow_back</i>
      <h1>
        {{assessment.assessment}}
      </h1>
      <div></div>
    </div>
    <assessment-results :results="breakDown" v-if="breakDown.length" />

  </div>
</template>

<script>
import notFound from "./404";
import assessmentResults from "@/components/assessmentResults";
import axios from "axios";

export default {
  components: { notFound, assessmentResults, },

  data() {
    return {
      results: [],
      loading: true,
      breakDown: [],
      assessment: {},

    };
  },

  created() {
    axios.get(`${process.env.VUE_APP_API_URL}clients/assessments/${this.$route.params.id}/`)
      .then(({data}) => {
        this.assessment = data;
      });

    axios.get(`${process.env.VUE_APP_API_URL}clients/assessments/${this.$route.params.id}/break_down/`)
      .then(({ data }) => {
        this.breakDown = data;
        this.loading = false;
      });
  },
  methods: {
    find() {
      this.loading = true;
    },
  },
  computed: {
    display() {
      return this.results.find(x => x.uuid === this.selected);
    },
  }
};
</script>
